import { useRef } from "react";
import { CustomStyledTextField } from "../mui-components/ColoredTextfield";
import LabeledTextField from "../mui-components/LabeledTextField";
import { FormControl, IconButton, InputAdornment } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { Controller } from "react-hook-form";


export function Quantity({control,rules,name,disabled,callback,getValues,onChange,width="90px"}){
    const inputRef = useRef(null);

  const handleUpArrowClick = (e) => {
    if(!disabled){
      if(onChange){
        onChange()
      }
      console.log(e.value,"===--==-=-=-===-==-=-");
      
      if(e.value.toString().length==0){
        callback(1) 
      }else{
        callback(Number(e.value)+1)
      }
      inputRef.current?.focus();
      const upArrowEvent = new KeyboardEvent('keydown', {
        key: 'ArrowUp',
        code: 'ArrowUp',
        keyCode: 38,
        which: 38,
        bubbles: true,
      });
  
      inputRef.current.dispatchEvent(upArrowEvent);
    }
  };

  const handleDownArrowClick = (e) => {
    if(!disabled){
      if(onChange){
        onChange()
      }
    if(e.value.toString().length==0){
      callback(0)
    }else{
      if(Number(e.value)>0){
        callback(Number(e.value)-1)
      }
    }
    inputRef.current?.focus();
    const downArrowEvent = new KeyboardEvent('keydown', {
      key: 'ArrowDown',
      code: 'ArrowDown',
      keyCode: 40,
      which: 40,
      bubbles: true,
    });

    inputRef.current.dispatchEvent(downArrowEvent);
  }
  };
    // return disabled ? <div className="w-[90px] h-[25px] bg-[#F3F3F3] rounded-[5px] flex items-center justify-center border-solid border-[0.5px] border-[#D4D4D4] font-[#555555]">{getValues(name)}</div>  : 
    return <FormControl>
      <Controller
       control={control}
       name={name}
       rules={rules}   
       render={({field,fieldState})=>{
        return  <div className="flex flex-row items-center">
        {/* <div onClick={handleDownArrowClick} className="h-full w-[30px] flex items-center justify-center cursor-pointer">-</div> */}
        <CustomStyledTextField 
        disabled = {disabled}
        error={!!fieldState.error} helperText={fieldState.error?.message} {...field}
        sx={{
          '& .MuiInputBase-input': {
      padding: '0',
      textAlign:'center'
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused": {
        fieldset: {
          borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
        },
      }},
        }} InputProps={{
          style:{
            padding:0,
            backgroundColor:"white",
            height:"25px",
            width:width,
            alignItems:"center",
            justifyContent:"center",
            display:"flex"
          },
          // disableUnderline:true,
          endAdornment:<div style={{padding:0,borderLeft:"0.5px solid #D4D4D4",height:"100%",minWidth:"25px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}  onClick={ disabled ? null: ()=>{
            handleUpArrowClick(field)
            }}>
            <Add sx={{fontSize:"16px",color:"#555555"}}/>
          </div>,
          startAdornment :  <div style={{padding:0,borderRight:"0.5px solid #D4D4D4",height:"100%",minWidth:"25px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}  onClick={disabled ? null:()=>{
            handleDownArrowClick(field)
            }}>
            <Remove sx={{fontSize:"16px",color:"#555555"}}/>
            </div>
          ,
        }} height="100%" type="number" ref={inputRef} onChange={(e)=>{
          field.onChange(e);
          if(onChange){
            onChange();
          }
        }} />
        {/* <div onClick={handleUpArrowClick} className="h-full w-[30px] flex items-center justify-center cursor-pointer">+</div> */}
    </div>
       }}
       />
    </FormControl>
   
}